import { render, staticRenderFns } from "./Coordenador-pesquisar.vue?vue&type=template&id=75da5b0c&"
import script from "./Coordenador-pesquisar.vue?vue&type=script&lang=js&"
export * from "./Coordenador-pesquisar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports